<template>
  <div class="wrapper" :style="cssProps">
    <div class="content">
      <div class="title__container">
        <p class="title__text">PARKING PAID</p>
      </div>

      <p class="gratitude__title">
        PARKING IS PAID,<br />
        PLEASE HEAD TO VALET TO RETRIEVE YOUR CAR
      </p>
    </div>
    <div class="footer">
      <div class="footer__content">
        <p class="footer__text">
          POWERED BY
          <span class="footer__text--underlined">parkenda</span>
        </p>
        <img
          class="footer__img"
          src="../../assets/new_design/PRKPRO_VerticalLogo_White 1.png"
          alt="PRKPRO_VerticalLogo_White"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058_1.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      }
    };
  },
  methods: {},
  mounted() {}
};
</script>

<style scoped src="../../styles/webrequest.main.css"></style>
<style scoped>
.rating__title {
  margin: 15vh auto 5vh auto;
  text-align: center;
  font-weight: normal;
  font-size: 1.34vh;
  line-height: 1.9vh;
  color: #fff;
}

.button {
  background-color: #fbae31;
  border: none;
  color: #fff;
  text-align: center;
  text-decoration: none;
  display: block;
  font-size: 2vh;
  margin: 3vh auto 3vh auto;
  height: 5.5vh;
  width: 50%;
  text-decoration: none;
  border-radius: 100px;
  overflow: hidden;
  cursor: pointer;
  outline: none;
}

.button__send {
  margin: 6vh auto 0 auto;
  width: 40%;
}
.button__thanks {
  background-color: #000;
  color: #fff;
  margin: 2vh auto 0 auto;
}
.modal__title {
  text-align: center;
  margin: 5.58vh 4.84vw 3.91vh 4.84vw;
  font-weight: normal;
  font-size: 1.78vh;
  line-height: 2.57vh;
}
.gratitude__title {
  margin: 25vh auto;
  font-weight: 700;
  font-size: 2vh;
  color: white;
  width: 60vw;
}
</style>



// WEBPACK FOOTER //
// src/components/WebRequest/ParkingPaid.vue